import type { StatEntry } from "../Types/StatItemType";
import { isStatDivider } from "../Types/StatItemType";

export function TabHeaderStats_({
  items,
  showDivider,
}: {
  items: StatEntry[];
  showDivider?: boolean;
}) {
  return (
    <div
      className={`flex items-center gap-5 ${showDivider ? "border-r-2 border-border pr-5" : ""}`}
    >
      {items.map((entry) => {
        if (isStatDivider(entry)) {
          return (
            <div
              key={entry.dividerId}
              className="h-6 w-px shrink-0 bg-border"
            />
          );
        }
        return (
          <div
            key={entry.statKey ?? String(entry.label)}
            className="flex items-baseline gap-1.5"
          >
            <span className="text-[11px] font-semibold tracking-wide whitespace-nowrap text-content-muted uppercase">
              {entry.label}
            </span>
            <span className="text-sm font-bold whitespace-nowrap text-foreground">
              {entry.value ?? "—"}
            </span>
          </div>
        );
      })}
    </div>
  );
}
